import { NextSeo } from "next-seo";
import SectionExplore from "domains/home/components/SectionExplore";
import SectionHighlights from "domains/home/components/SectionHighlights";
import SectionTools from "domains/home/components/SectionTools";
import { useTeamContext } from "domains/teams/contexts/TeamProvider";
import Alert from "domains/ui/components/Alert";
import Footer from "domains/ui/components/Footer";
import { useIntl } from "react-intl";

import { VStack } from "@chakra-ui/react";

export default function Home() {
  const intl = useIntl();
  const { hasNoProject } = useTeamContext();

  return (
    <>
      <NextSeo
        title={intl.formatMessage({
          id: "pages.index.title",
          defaultMessage: "Home",
        })}
      />

      {hasNoProject ? (
        <VStack
          align="stretch"
          w="100%"
          maxW="1650px"
          mx="auto"
          pt={6}
          px={9}
          spacing={6}
        >
          <Alert
            type="info"
            title="Contact an admin of the Organization to join a Project."
          />
        </VStack>
      ) : (
        <VStack
          align="stretch"
          w="100%"
          maxW="1400px"
          mx="auto"
          px={9}
          py={10}
          spacing="60px"
        >
          <SectionHighlights />
          <SectionTools />
          <SectionExplore />
        </VStack>
      )}

      <Footer />
    </>
  );
}
